import { defineStore } from "pinia";
import axios from "axios";

export const useProductsModule = defineStore("productsModule", {
  state: () => ({
    singleProduct: "",
    topsales: [],
    topsalesCat: [
      {
        title: "الكتب الأكثر مبيعا",
        route: "top-sale",
      },
    ],
    cat7pro: [],
    islamic: [],
    economy: [],
    amiliorer: [],
    roman: [],
    categoryProducts: [],
    category: [],
    categories: [
      {
        title: "كتب فرنسية",
        route: "كتب-فرنسية",
      },
      {
        title: "كتب دينية",
        route: "كتب-دينية",
      },
      {
        title: "كتب فلسفية ",
        route: "كتب-فلسفية",
      },
      {
        title: "كتب التنمية الذاتية",
        route: "كتب-التنمية-الذاتية",
      },
      {
        title: "كتب إقتصاد و أعمال",
        route: "كتب-إقتصاد-و-أعمال",
      },
      {
        title: "كتب علم النفس",
        route: "كتب-علم-النفس",
      },
      {
        title: "روايات",
        route: "روايات",
      },
      {
        title: "كتب سياسية",
        route: "كتب-سياسية",
      },
      {
        title: "كتب اجتماعية",
        route: "كتب-اجتماعية",
      },
      {
        title: "كتب إنجليزية",
        route: "كتب-إنجليزية",
      },
    ],
  }),
  actions: {
    async getProductstop() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/13`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.topsales = shuffledData.slice(0, 10); // Assuming the response contains the top sales products directly
      } catch (err) {
        console.error(err); // Log any errors
      }
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/10`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.roman = shuffledData.slice(0, 10); // Assuming the response contains the top sales products directly
      } catch (err) {
        console.error(err); // Log any errors
      }
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/6`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.amiliorer = shuffledData.slice(0, 10); // Assuming the response contains the top sales products directly
      } catch (err) {
        console.error(err); // Log any errors
      }
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/7`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.cat7pro = shuffledData.slice(0, 10);
      } catch (err) {
        console.error(err); // Log any errors
      }
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/8`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.economy = shuffledData.slice(0, 10);
      } catch (err) {
        console.error(err); // Log any errors
      }
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/3`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.islamic = shuffledData.slice(0, 10);
      } catch (err) {
        console.error(err); // Log any errors
      }
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/categories`
        );
        const shuffledData = res.data.sort(() => Math.random() - 0.5);
        this.category = shuffledData.slice(0, 10);
      } catch (err) {
        console.error(err); // Log any errors
      }
    },
    async getProductByCategory(category) {
      await axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/products/category/name/${category}`
        )
        .then((res) => (this.categoryProducts = res.data));
    },
    async getSingleProduct(productId) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/products/${productId}`
        );
        this.singleProduct = res.data;

        // If product not found, you could return null or handle it here
        return this.singleProduct;
      } catch (error) {
        // Handle 404 or other errors
        if (error.response && error.response.status === 404) {
          return null; // Return null if product not found
        }
        throw error; // Rethrow other errors
      }
    },
  },
});
